import { withInstall } from '../../utils/install';
import Scrollbar from './index.vue';

export const IvueScrollbar = withInstall(Scrollbar);
export default IvueScrollbar;

export * from './index.vue';
